import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css';
import api from '../services/api';

const WachtwoordVergeten = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await api.post('/password-reset/request', { email });
      
      if (response.data.success) {
        setSuccess(true);
      }
    } catch (err) {
      setError('Er is iets misgegaan. Probeer het later opnieuw.');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="login-container">
        <div className="login-box">
          <div className="login-header">
            <h1>✅ Email Verzonden</h1>
          </div>
          <div style={{ padding: '20px', textAlign: 'center' }}>
            <p>Als dit emailadres bij ons bekend is, hebben we een reset link verzonden.</p>
            <p style={{ marginTop: '20px', color: '#666' }}>
              Check je inbox en klik op de link om je wachtwoord te resetten.
            </p>
            <button 
              onClick={() => navigate('/login')}
              className="btn-primary"
              style={{ marginTop: '30px' }}
            >
              Terug naar Inloggen
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-header">
          <h1>Wachtwoord Vergeten</h1>
          <p>Vul je emailadres in om een reset link te ontvangen</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          {error && (
            <div className="error-message">
              {error}
            </div>
          )}

          <div className="form-group">
            <label htmlFor="email">Email adres</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoFocus
              disabled={loading}
              placeholder="jouw@email.nl"
            />
          </div>

          <button
            type="submit"
            className="btn-primary"
            disabled={loading}
          >
            {loading ? 'Verzenden...' : 'Verstuur Reset Link'}
          </button>
        </form>

        <div className="login-footer">
          <p>
            <a onClick={() => navigate('/login')} style={{ cursor: 'pointer' }}>
              ← Terug naar inloggen
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default WachtwoordVergeten;
